import { Card, Form, Input } from "antd";
import React from "react";
import BpsButton from "../../ui/Button/Button";
import BpsHeader from "../../ui/Header/Header";

const Security = () => {
  return (
    <div className="Security">
      <BpsHeader page={"Security"} />
      <Card className="bps-security__container">
        <p>Change password</p>
        <Form name="basic" layout="vertical" autoComplete="off">
          <Form.Item
            label={<label>Old password</label>}
            name="Old password"
            className="bps-security__inputWrapper"
            rules={[{ required: true }]}
            hasFeedback
          >
            <Input.Password
              className="bps-security__password"
              placeholder="********"
            />
          </Form.Item>
          <Form.Item
            label={<label>New password</label>}
            name="New password"
            className="bps-security__inputWrapper"
            rules={[{ required: true }]}
            hasFeedback
          >
            <Input.Password
              className="bps-security__password"
              placeholder="********"
            />
          </Form.Item>
          <Form.Item
            label={<label>Repeat password</label>}
            name="Repeat password"
            className="bps-security__inputWrapper"
            rules={[{ required: true }]}
            hasFeedback
          >
            <Input.Password
              className="bps-security__password"
              placeholder="********"
            />
          </Form.Item>
          <Form.Item>
            <BpsButton
              label={"Access account"}
              customClass="bps-security__button"
              shape="rounded"
              buttonType="primary"
            />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Security;
